// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yorb","question":"styles_question__1p6fW","description":"styles_description__3DSvr"};